// Mascara de documento conforme o tipo: CPF (000.000.000-00) ou CNPJ (00.000.000/0000-00).
// Mantem apenas digitos e aplica a formatacao progressivamente (serve para digitacao e exibicao).
export const maskDocument = (
  value: string | null | undefined,
  type?: "juridica" | "fisica"
): string => {
  // Entidade sem documento cadastrado é caso real (8 na base do primeiro cliente, e toda
  // entidade recém-criada pelo provisionamento nasce assim). Sem esta guarda, o `.replace`
  // num nulo derruba a TELA INTEIRA na montagem — foi o que aconteceu em 16/09/2026.
  if (!value) {
    return "";
  }
  if (type === "fisica") {
    return value
      .replace(/\D/g, "")
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return value
    .replace(/\D/g, "")
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

// Validacao de CPF pelos digitos verificadores (modulo 11). Rejeita tamanho errado e digitos repetidos.
export const isValidCpf = (value: string): boolean => {
  const cpf = value.replace(/\D/g, "");
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const digit = (length: number): number => {
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += parseInt(cpf[i], 10) * (length + 1 - i);
    }
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };

  return digit(9) === parseInt(cpf[9], 10) && digit(10) === parseInt(cpf[10], 10);
};

// Validacao de CNPJ pelos digitos verificadores (modulo 11). Rejeita tamanho errado e digitos repetidos.
export const isValidCnpj = (value: string): boolean => {
  const cnpj = value.replace(/\D/g, "");
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  const digit = (length: number): number => {
    const weights =
      length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += parseInt(cnpj[i], 10) * weights[i];
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  return (
    digit(12) === parseInt(cnpj[12], 10) && digit(13) === parseInt(cnpj[13], 10)
  );
};

// Valida o documento conforme o tipo da entidade (juridica = CNPJ, fisica = CPF).
export const isValidDocument = (
  value: string,
  type?: "juridica" | "fisica"
): boolean => (type === "fisica" ? isValidCpf(value) : isValidCnpj(value));
